"use client";

import type * as React from "react";
import { Fragment, useMemo } from "react";
import { VehicleCard } from "@/components/booking/VehicleCard";
import {
  chunkIntoRows,
  useGridColumns,
} from "@/lib/hooks/use-grid-columns";
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import {
  selectSelectedVehicleId,
  setSelectedVehicle,
} from "@/lib/redux/features/vehicles/vehiclesSlice";
import type { Vehicle } from "@/lib/vehicles";

type BookingVehicleListProps = {
  vehicles: Vehicle[];
};

export const BookingVehicleList: React.FC<BookingVehicleListProps> = ({
  vehicles,
}) => {
  const dispatch = useAppDispatch();
  const selectedVehicleId = useAppSelector(selectSelectedVehicleId);
  const gridColumns = useGridColumns();

  const vehicleRows = useMemo(
    () => chunkIntoRows(vehicles, gridColumns),
    [vehicles, gridColumns],
  );

  if (vehicles.length === 0) {
    return (
      <p className="col-span-full py-12 text-center text-sm text-gray-500">
        No vehicles found for this search.
      </p>
    );
  }

  const handleSelect = (vehicle: Vehicle) => {
    dispatch(
      setSelectedVehicle(
        selectedVehicleId === vehicle.type_id ? null : vehicle.type_id,
      ),
    );
  };

  return (
    <>
      {vehicleRows.map((row, rowIndex) => (
        <Fragment key={`vehicle-row-${rowIndex}`}>
          {row.map((vehicle) => {
            const isSelected = selectedVehicleId === vehicle.type_id;

            return (
              <VehicleCard
                key={vehicle.type_id}
                vehicle={vehicle}
                isSelected={isSelected}
                onSelect={handleSelect}
              />
            );
          })}

          {/* Vehicle detail panel removed — selection only highlights the card
          {selectedInRow && selectedVehicle ? (
            <div ref={detailsRef} className="col-span-full">
              <VehicleDetailsPanel
                vehicle={selectedVehicle}
                onClose={() => dispatch(setSelectedVehicle(null))}
              />
            </div>
          ) : null}
          */}
        </Fragment>
      ))}
    </>
  );
};
